module.exports = __webpack_public_path__ + "media/images/icon_list/group-00820714688180b6e64c42c237ec558b.svg";